// Status Step Constants
export const STATUS_STEPS = {
    INITIAL_PAYMENT: {
        id: 1,
        key: 'INITIAL_PAYMENT',
        dbKey: 'initial payment'
    },
    FETCHED: {
        id: 2,
        key: 'FETCHED',
        dbKey: 'fetched'
    },
    VALIDATED: {
        id: 3,
        key: 'VALIDATED',
        dbKey: 'validated'
    },
    DIFFERENCE_TO_PAY: {
        id: 4,
        key: 'DIFFERENCE_TO_PAY',
        dbKey: 'difference to pay'
    },
    DIFFERENCE_PAID: {
        id: 5,
        key: 'DIFFERENCE_PAID',
        dbKey: 'difference paid'
    },
    FULFILLED: {
        id: 6,
        key: 'FULFILLED',
        dbKey: 'fulfilled'
    },
    COMPLETED: {
        id: 7,
        key: 'COMPLETED',
        dbKey: 'completed'
    },
    PACKED: {
        id: 8,
        key: 'PACKED',
        dbKey: 'packed'
    },
    DELIVERED: {
        id: 9,
        key: 'DELIVERED',
        dbKey: 'delivered'
    }
};

// Helper functions
export const getStatusStepById = (id) => {
    return Object.values(STATUS_STEPS).find(step => step.id === id);
};

export const getStatusStepByKey = (key) => {
    return Object.values(STATUS_STEPS).find(step => step.key === key);
};

export const getStatusStepByDbKey = (dbKey) => {
    return Object.values(STATUS_STEPS).find(step => step.dbKey === dbKey);
};

export const getAllStatusSteps = () => {
    return Object.values(STATUS_STEPS).sort((a, b) => a.id - b.id);
};
